import { ToothRestorationMaterial } from '../../../../graphql/graphql';

interface SurfaceMaterialColor {
	base: string;
	outline: string;
}

export const TOOTH_SURFACE_MATERIAL_COLORS: Record<
	ToothRestorationMaterial,
	SurfaceMaterialColor
> = {
	[ToothRestorationMaterial.Gold]: {
		base: '#eabc0e',
		outline: '#af8d0a',
	},
	[ToothRestorationMaterial.Ceramic]: {
		base: '#9e56d5',
		outline: '#76409f',
	},
	[ToothRestorationMaterial.Composite]: {
		base: '#5dbced',
		outline: '#458db1',
	},
	[ToothRestorationMaterial.NonPreciousMaterial]: {
		base: '#c6c6d3',
		outline: '#94949e',
	},
	[ToothRestorationMaterial.Amalgam]: {
		base: '#adb2b5',
		outline: '#818587',
	},
	[ToothRestorationMaterial.Temporary]: {
		base: '#9aedec',
		outline: '#73b1b1',
	},
	[ToothRestorationMaterial.GlassIonomer]: {
		base: '#8fd4a8',
		outline: '#6aa882',
	},
	[ToothRestorationMaterial.MetalCeramic]: {
		base: '#b8a8c8',
		outline: '#8a7a9a',
	},
} as const;
